import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/dovelp.jpg";
import emotion from "../../Assets/Projects/Charan.jpg";
import editor from "../../Assets/Projects/afaj1.jpg";
import chatify from "../../Assets/Projects/Rankhigh.jpg";
import suicide from "../../Assets/Projects/blockbusterevents.jpg";
import bitsOfCode from "../../Assets/Projects/Astrodaulat.jpg";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="rankhigh.ai"
              description="We at rankhigh.ai are committed to assisting you in improving the functionality of your website and positioning it higher in search engine results. No matter who you are—a person, a business owner, or a developer—our robust array of SEO Studio tools is here to help you at every turn."
              demoLink="https://rankhigh.ai/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="astrodaulat.com"
              description="Made Astrologer website for a client and with the knowledge of web development i have inti grated mt creativeness thinking to full filled this product on time with 3D aminations ."
              demoLink="https://astrodaulat.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="afaj.co.uk"
              description="Make Furniture  Website for Customer requirment,Explore our celestial-inspired furniture collection, where luxury meets cosmic elegance. Discover our Galaxy Sofa Set, Luminary Dining Table, Aurora Nightstands, Nova Writing Desk, Celestial Canopy Bed, and Eclipse Lounge Chair. Elevate your living space with our meticulously crafted pieces that redefine comfort and style, "
              demoLink="https://afaj.co.uk"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="dovelp.com"
              description="Working on dovelp,afaj,and fixing bugs and issues on the code base."
              // ghLink="https://dovelp.com/"
              demoLink="https://dovelp.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={suicide}
              isBlog={false}
              title="Blockbusterevents "
              description="Making a Blockbusterevents Landing Page Website."
              // ghLink="https://blockbusterevents.co.uk/"
              demoLink="https://blockbusterevents.co.uk/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="Vegetable Website"
              description="Making a Charan Landing Page Website."
              // ghLink="https://charan.biz/"
              demoLink="https://charan.biz/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
